import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="utils--confirm-with-input"
export default class extends Controller {
  static values = { prompt: String, param: String, default: String }

  showPrompt(event) {
    event.preventDefault()

    if (!this.promptValue || !this.paramValue) {
      console.error("Missing `data-confirm-with-input-prompt-value` or `data-confirm-with-input-param-value` attributes.")
      return
    }

    const url = this.element.href
    const method = this.element.dataset.turboMethod || "get"

    const userInput = prompt(this.promptValue, this.defaultValue)
    if (userInput === null) return // User canceled

    const newUrl = this.appendParamToUrl(url, this.paramValue, userInput)

    if (method === "get") {
      Turbo.visit(newUrl) // Use Turbo for GET requests
    } else {
      this.submitForm(newUrl, method) // Use Fetch for non-GET requests
    }
  }

  appendParamToUrl(url, param, value) {
    const urlObj = new URL(url, window.location.origin)
    urlObj.searchParams.set(param, value)
    return urlObj.toString()
  }

  submitForm(url, method) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(url, {
      method: method.toUpperCase(),
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html, text/html, application/json"
      },
      credentials: "same-origin"
    }).then(response => {
      if (response.redirected) {
        Turbo.visit(response.url)
      }
    })
  }
}